import React from 'react';
import css from './MyMarshfieldClinic.module.css';
import {
  ButtonType,
  H2,
  Image,
  Paragraph,
  StackedColumn,
  StackedColumnSpacing,
  StackedRow,
  TextButton,
} from '../../../core';
import { ComputerImage } from '../../../core/assets/images';
import { EnvironmentExtended } from '../../../environment/index';
import clsx from 'clsx';

const haveYouBeenSeen =
  'Have you been seen at Marshfield Clinic Health System before?';
const manageHealtCare =
  'Manage health care on your time. My Marshfield Clinic is your go-to place for organizing health care available via our website or through the mobile app. For most patients, sign-up only takes minutes.';
const newPatient1 = 'New to ';
const newPatient2 = 'My Marshfield Clinic';
const newPatient3 = '? Create an account to learn more.';
const alreadyPatient =
  'If you already have an account, sign in to manage your health care.';

interface MyMarshfieldClinicProps {
  asFooter: boolean;
}

const MyMarshfieldClinic: React.FC<MyMarshfieldClinicProps> = (
  props: MyMarshfieldClinicProps
) => {
  const onCreateAccount = () => {
    window.open(
      `${EnvironmentExtended.getMyMarshfieldClinicCreateUrl()}`,
      '_blank'
    );
  };

  const onSignIn = () => {
    window.open(
      `${EnvironmentExtended.getMyMarshfieldClinicSignInUrl()}`,
      '_blank'
    );
  };

  return (
    <div className={clsx(css.myMarshfieldClinic, props.asFooter ? null : css.callout)}>
      <StackedColumn>
        {props.asFooter ? <div className={css.horizontalLine} /> : null}
        <StackedRow>
          <div className={css.imageContainer}>
            <Image
              source={ComputerImage}
              alternateText={'My Marshfield Clinic'}
              height={30}
              width={30}
            />
          </div>
          <H2 text="My Marshfield Clinic" />
        </StackedRow>
        <StackedColumn spacing={StackedColumnSpacing.NoGap}>
          <Paragraph text={haveYouBeenSeen} bold={true} />
          <Paragraph text={manageHealtCare} />
        </StackedColumn>
        <div>
          <Paragraph text={newPatient1} />
          <Paragraph text={newPatient2} bold={true} />
          <Paragraph text={newPatient3} />
        </div>
        <div className={css.accountButtonContainer}>
          <TextButton
            caption="Create account"
            buttonType={ButtonType.Secondary}
            onClick={onCreateAccount}
          />
        </div>
        <Paragraph text={alreadyPatient} />
        <div className={css.accountButtonContainer}>
          <TextButton
            caption="Sign in"
            buttonType={ButtonType.Primary}
            onClick={onSignIn}
          />
        </div>
      </StackedColumn>
    </div>
  );
};

export default MyMarshfieldClinic;
